document.querySelectorAll('#gateway-modal, #site-header-search').forEach(modal => {
    modal.addEventListener('shown.bs.modal', function() {
        const modalBackdrops = document.querySelectorAll('.modal-backdrop');
        modalBackdrops.forEach(backdrop => {
            backdrop.style.zIndex = '980';
        });
    });
});

const headerElement = document.querySelector("header.site-header");
const headerHeight = headerElement ? headerElement.offsetHeight : 0;

function adjustHeaderHeight() {
    const alertBars = Array.from(document.querySelectorAll(".alert-bar"));
    const alertBarsHeight = alertBars.reduce((prev, curr) => {
        return curr.offsetHeight + prev;
    }, 0);
    
    const stickyWrapper = document.querySelector("#root > .bs4-nav > .sticky-wrapper");
    if (stickyWrapper) {
        stickyWrapper.style.height = (headerHeight + alertBarsHeight) + 'px';
    }
    
    const firstNav = document.querySelector("body > .bs4-nav:first-child");
    if (firstNav) {
        firstNav.style.height = (headerHeight + alertBarsHeight) + 'px';
    }
}

adjustHeaderHeight();